/**
 * Priorytet komunikatu przychodzi z API jako STRING ("Info"/"Warning"/"Critical"/"Rodo") —
 * globalny JsonStringEnumConverter serializuje enumy nazwami. Czesc frontu porownywala go
 * z liczbami (0/1/2/99), przez co np. komunikat krytyczny dostawal kolor "Info".
 * Jedno zrodlo prawdy: normalizacja do liczby, przyjmujaca OBA formaty.
 */
const FROM_NAME = { Info: 0, Warning: 1, Critical: 2, Rodo: 99 };

export const normAnnPriority = (p) => {
    if (typeof p === "string") return FROM_NAME[p] ?? 0;
    const n = Number(p);
    return Number.isFinite(n) ? n : 0;
};

/**
 * [polecenie właściciela 2026-09-17] KATEGORIA KOMUNIKATU JAKO ZDANIE — dopisane, nie nadpisane
 * (lekcja z `utils/bladSerwera.js`: nadpisanie pliku „przy okazji" skasowało kiedyś cudzy eksport).
 *
 * Właściciel: „W pasku wyświetlaj tytuł, kategorię oraz 2 pierwsze linijki". Etykieta typu komunikatu
 * była dotąd przepisana w CZTERECH miejscach z własnymi brzmieniami — edytor („Alert Krytyczny”),
 * lista administracyjna („KRYTYCZNY”), bramka („Krytyczne”) i centrum powiadomień. Pasek jest piątym
 * ekranem pokazującym to samo pole, więc nazwa idzie z jednego miejsca, obok normalizacji, którą
 * i tak musi wykonać (priorytet przychodzi z API NAZWĄ enuma).
 */
const ETYKIETY = {
    0: "Informacja",
    1: "Ostrzeżenie",
    2: "Alert krytyczny",
    99: "RODO / Regulamin",
};

/** Kategoria komunikatu po polsku — przyjmuje i liczbę, i nazwę enuma z API. */
export const etykietaAnnPriority = (p) => ETYKIETY[normAnnPriority(p)] || ETYKIETY[0];

/**
 * [polecenie właściciela 2026-10-04] Nazwa WARIANTU paska nad nagłówkiem: Informacja / Ostrzeżenie / Pilne.
 * Pasek ma trzy warianty wyglądu i w edytorze nazywają się właśnie tak — ten sam napis musi stać na pasku,
 * w podglądzie i w oknie pełnej treści („Alert krytyczny” to nazwa komunikatu-okna, nie paska).
 * RODO paskiem nie bywa (wymaga okna z potwierdzeniem); stary taki pasek zachowuje swoją nazwę.
 */
const WARIANTY_PASKA = { 0: "Informacja", 1: "Ostrzeżenie", 2: "Pilne" };
export const etykietaWariantuPaska = (p) => WARIANTY_PASKA[normAnnPriority(p)] || etykietaAnnPriority(p);
